import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { connect } from 'react-redux';
import MembershipForm from '../MembershipForm';
import AdditionalMembershipsForm from '../AdditionalMembershipsForm';
import MembershipHistoryForm from '../MembershipHistoryForm';
import MembershipNotesForm from '../MembershipNotesForm';
import MembershipAudit from '../MembershipAudit/MembershipAudit';

class DialogContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: "details"
        };
    }

    componentDidMount() {

    }

    changeView = (view) => {
        this.setState({
            view: view
        })
    }

    render() {
        return (
            <div className="k-window-content">
                <div className="row " style={{width: '100%'}}>
                    <div className="col-md-3">
                        <ul className="subSideNav">
                            <li onClick={() => this.changeView("details")} className={this.state.view === "details" ? "active" : "", "stylingli"} >Member Details</li>
                            <li onClick={() => this.changeView("additionalMembers")} className={this.state.view === "additionalMembers" ? "active" : "","stylingli"} >Members</li>
                            <li onClick={() => this.changeView("history")} className={this.state.view === "history" ? "history" : "", "stylingli"} >Membership Transactions</li>
                            <li onClick={() => this.changeView("notes")} className={this.state.view === "notes" ? "notes" : "", "stylingli"} >Notes</li>
                            <li onClick={() => this.changeView("audit")} className={this.state.view === "audit" ? "audit" : "", "stylingli"} >Audit History</li>
                        </ul>
                    </div>
                    <div className="col-md-9">
                        {this.state.view === "details" ?
                            <MembershipForm
                                dataItem={this.props.dataItem}
                                save={this.props.save}
                                cancel={this.props.cancel}
                                saveAdminMembership={this.props.saveAdminMembership}
                            />
                        : ""}
                        {this.state.view === "additionalMembers" ?
                            <AdditionalMembershipsForm
                            dataItem={this.props.dataItem}
                            save={this.props.save}
                            cancel={this.props.cancel}
                            saveAdminMembership={this.props.saveAdminMembership}
                        />
                        : ""}
                        {this.state.view === "history" ?
                            <MembershipHistoryForm
                            dataItem={this.props.dataItem}
                            // save={this.props.save}
                            cancel={this.props.cancel}
                            // saveAdminMembership={this.props.saveAdminMembership}
                        />
                        : ""}
                          {this.state.view === "notes" ?
                            <MembershipNotesForm
                            dataItem={this.props.dataItem}
                            cancel={this.props.cancel}
                                                    />
                        : ""}
                        {this.state.view === "audit" ?
                            <MembershipAudit
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                            />
                         : ""}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        committee: state.committee,
        position: state.position
    };
}

export default connect(mapStateToProps, {})(DialogContainer);
